const common = {
  /**
   * 
   * @param {Number} value 需要格式化的数字
   * @param {string} currency 价格符号
   * @param {Number} decimals 保留小数点后位数
   */
  currency(value, currency, decimals) {
    const digitsRE = /(\d{3})(?=\d)/g
    value = parseFloat(value)
    if (!isFinite(value) || (!value && value !== 0)) return ''
    currency = currency != null ? currency : '$'
    decimals = decimals != null ? decimals : 2
    let stringified = Math.abs(value).toFixed(decimals)
    let _int = decimals ?
      stringified.slice(0, -1 - decimals) :
      stringified
    let i = _int.length % 3
    let head = i > 0 ?
      (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) :
      ''
    let _float = decimals ?
      stringified.slice(-1 - decimals) :
      ''
    let sign = value < 0 ? '-' : ''
    return sign + currency + head +
      _int.slice(i).replace(digitsRE, '$1,') +
      _float

  },
  // 替换邮箱字符
  regEmail(email) {
    if (String(email).indexOf('@') > 0) {
      var str = email.split('@'),
        _s = '';
      if (str[0].length > 3) {
        for (var i = 0; i < str[0].length - 3; i++) { _s += '*'; }
      }
      var new_email = str[0].substr(0, 3) + _s + '@' + str[1]
    }
    return new_email
  },

  // 替换手机字符
  regMobile(mobile) {
    if (mobile.length > 7) {
      var new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7)
    }
    return new_mobile
  },

  dateFtt(fmt, date, symbol, num) { // fmt时间格式、date日期、symbol加减符号、num天数
    var o = {
      "M+": date.getMonth() + 1, //月份   
      "d+": date.getDate(), //日   
      "h+": date.getHours(), //小时   
      "m+": date.getMinutes(), //分   
      "s+": date.getSeconds(), //秒   
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
      "S": date.getMilliseconds() //毫秒   
    };
    if (symbol != undefined && !!num) {
      if (symbol == 0) { //加
        o["d+"] = o["d+"] + num;
      } else {
        o["d+"] = o["d+"] - num;
      }
    }
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  // 时间格式化
  dateformat(date) {
    let time = new Date(date)
    return time.getFullYear() + '-' + this.dateFill(time.getMonth() + 1) + '-' + this.dateFill(time.getDate())
  },
  dateFill(time) {
    return time > 9 ? time : '0' + time
  },
}

export default common


// WEBPACK FOOTER //
// ./src/utils/currency.js